// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2uOP2","loaderOuter":"PageOverlayLoader_loaderOuter__34Whl"};